import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllVentes, getPlatVenteSummary, getProduitVenteSummary, getVenteSummary } from '../store/venteSlice';

function Ventes() {
  const { produitList } = useSelector((state) => state.produit);
  const { platList, produitListParPlat } = useSelector((state) => state.plat);
  const { venteList, venteSummary, ventPlat, ventProduit } = useSelector((state) => state.vente);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllVentes());
    dispatch(getPlatVenteSummary());
    dispatch(getProduitVenteSummary());
    dispatch(getVenteSummary());
  }, [dispatch]);


  //console.log("venteSummary", venteSummary);

  function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  return (
    <>
      {/* congrats & summary */}
      <div className="gap-5 grid grid-cols-3 lg:grid-cols-1">
        {/* congrats */}
        <div className="col-span-1 card">

          <div className="flex flex-col justify-between h-full card-body">

            <div>
              <h1 className="font-bold text-lg tracking-wide">Ventes du mois</h1>
              <p className="mt-2 text-gray-600">Best seller of the month</p>
            </div>

            <div className="flex flex-row items-end mt-10">

              <div className="flex-1">
                <h1 className="font-extrabold text-4xl text-teal-400">{formatPrice(venteSummary.thisMonth || 0)} Kmf</h1>
                <p className="mt-3 mb-4 text-gray-500 text-xs">You have done 57.6% more sales today.</p>
                <a href="#" className="btn-shadow py-3">
                  view sales
                </a>
              </div>
            </div>

          </div>

        </div>
        {/* end congrats */}
        <div className="flex flex-row lg:flex-col col-span-2 lg:col-span-1 p-0 overflow-hidden card">
          {/* left */}
          <div className="w-2/3 lg:w-full">

            {/* top */}
            <div className="border-gray-200 p-5 border-b">
              <h2 className="mb-6 font-bold text-lg">Historique Ventes</h2>

              {/* Historique ventes */}
              {
                venteList.ventes?
                venteList.ventes.map((vente, index) => (
                  <div className="flex flex-row justify-between mb-3" key={index}>
                    <div className="">
                      <h4 className="font-thin text-gray-600">{vente.description}</h4>
                      <p className="font-hairline text-gray-400 text-xs">{vente.timeAgo}</p>
                    </div>
                    <div className="font-medium text-sm">
                      <span className="text-green-400">+</span> {formatPrice(vente.amount)} Kmf
                    </div>
                  </div>
                )) :
                <p className="font-medium text-sm">Chargement...</p>
              }
            </div>
            {/* end top */}

            {/* bottom */}
            <div className="p-5">
              <h2 className="mb-2 font-bold text-lg">Total ventes</h2>
              <strong className="font-extrabold text-teal-400 text-xl">{formatPrice(venteList.totalVentes || 0)} Kmf</strong>

              <div className="relative bg-gray-300 mt-2 rounded-full h-2">
                <div className="bg-teal-400 shadow-md rounded-full w-3/4 h-full"></div>
              </div>
            </div>
            {/* end bottom */}

          </div>
          {/* end left */}

        </div>

      </div>
      {/* end congrats & summary */}

      {/* status */}
      <div className="gap-5 grid grid-cols-5 lg:grid-cols-2 mt-5">

        {/* status */}
        <div className="col-span-1 card">
          <div className="card-body">
            <h5 className="font-extrabold text-xs uppercase tracking-wider">Aujourd'hui</h5>
            <h1 className="mt-1 mb-1 text-lg capitalize">{formatPrice(venteSummary.today || 0)} Kmf</h1>
            <p className="text-gray-500 text-xs capitalize">( $<span className="num-2"></span> in the last year )</p>
          </div>
        </div>
        {/* status */}

        {/* status */}
        <div className="col-span-1 card">
          <div className="card-body">
            <h5 className="font-extrabold text-xs uppercase tracking-wider">Hier</h5>
            <h1 className="mt-1 mb-1 text-lg capitalize">{formatPrice(venteSummary.yesterday || 0)} Kmf</h1>
            <p className="text-gray-500 text-xs capitalize">( $<span className="num-2"></span> in the last year )</p>
          </div>
        </div>
        {/* status */}

        {/* status */}
        <div className="col-span-1 card">
          <div className="card-body">
            <h5 className="font-extrabold text-xs uppercase tracking-wider">Dernière Semaine</h5>
            <h1 className="mt-1 mb-1 text-lg capitalize">{formatPrice(venteSummary.lastWeek || 0)} Kmf</h1>
            <p className="text-gray-500 text-xs capitalize">( $<span className="num-2"></span> in the last year )</p>
          </div>
        </div>
        {/* status */}

        {/* status */}
        <div className="col-span-1 card">
          <div className="card-body">
            <h5 className="font-extrabold text-xs uppercase tracking-wider">Dernier mois</h5>
            <h1 className="mt-1 mb-1 text-lg capitalize">{formatPrice(venteSummary.lastMonth || 0)} Kmf</h1>
            <p className="text-gray-500 text-xs capitalize">( $<span className="num-2"></span> in the last year )</p>
          </div>
        </div>
        {/* status */}

        {/* status */}
        <div className="col-span-1 lg:col-span-2 card">
          <div className="card-body">
            <h5 className="font-extrabold text-xs uppercase tracking-wider">Dernier 90 jours</h5>
            <h1 className="mt-1 mb-1 text-lg capitalize">{formatPrice(venteSummary.last90Days || 0)} Kmf</h1>
            <p className="text-gray-500 text-xs capitalize">( $<span className="num-2"></span> in the last year )</p>
          </div>
        </div>
        {/* status */}


      </div>
      {/* end status */}

      {/* best seller & traffic */}
      <div className="gap-5 grid grid-cols-2 lg:grid-cols-1 mt-5">
        <div className="card">
          <div className="card-body">
            <div className="flex flex-row justify-between items-center">
              <h1 className="font-extrabold text-lg">Plats plus vendus</h1>
              <a href="#" className="text-sm btn-gray">Tout Voir</a>
            </div>

            <table className="text-right mt-3 w-full table-auto">

              <thead>
                <tr>
                  <td className="py-4 font-extrabold text-left text-sm">Menus</td>
                  <td className="py-4 font-extrabold text-sm">Qt</td>
                  <td className="py-4 font-extrabold text-sm">sold</td>
                </tr>
              </thead>

              <tbody>

                {/* VentePlat */}
                {ventPlat.map((plat) => (
                  <tr className="" key={plat.platId}>
                    <td className="flex flex-row items-center text-gray-600 text-left text-sm">
                      <div className="mr-3 w-8 h-8 overflow-hidden">
                        <img src={plat.platPhoto} className="rounded-full object-cover" />
                      </div>
                      {plat.platName}
                    </td>
                    <td className="py-4 text-gray-600 text-xs"><span className="num-2">{formatPrice(plat.totalQuantity)}</span></td>
                    <td className="py-4 text-gray-600 text-xs"><span className="num-3">{formatPrice(plat.totalSold)}</span></td>
                  </tr>
                ))}
                {/* end VentePlat */}
              </tbody>

            </table>

          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="flex flex-row justify-between items-center">
              <h1 className="font-extrabold text-lg">Produits plus vendus</h1>
              <a href="#" className="text-sm btn-gray">Tout Voir</a>
            </div>

            <table className="text-right mt-3 w-full table-auto">

              <thead>
                <tr>
                  <td className="py-4 font-extrabold text-left text-sm">Boissons</td>
                  <td className="py-4 font-extrabold text-sm">Qt</td>
                  <td className="py-4 font-extrabold text-sm">sold</td>
                </tr>
              </thead>

              <tbody>

                {/* venteProduit */}
                {ventProduit.map((produit) => (
                  <tr className="" key={produit.produitId}>
                    <td className="flex flex-row items-center text-gray-600 text-left text-sm">
                      <div className="mr-3 w-8 h-8 overflow-hidden">
                        <img src={produit.produitPhoto} className="rounded-full object-cover" />
                      </div>
                      {produit.produitName}
                    </td>
                    <td className="py-4 text-gray-600 text-xs"><span className="num-2">{formatPrice(produit.totalQuantity)}</span></td>
                    <td className="py-4 text-gray-600 text-xs"><span className="num-3">{formatPrice(produit.totalSold)}</span></td>
                  </tr>
                ))}
                {/* end venteProduit */}

              </tbody>

            </table>

          </div>
        </div>
      </div>
    </>
  )
}

export default Ventes